import React, { useEffect, useState } from "react";
import { Card, Container, Div, Text } from "../../styles/Common";
import { theme } from "../../styles/theme";
import { Button } from "../../components/Button";
import { useMediaQuery } from "react-responsive";
import { Bullet, NotificationsWrapper, NotificationsContainer } from "./styles";
import { Link } from "../../components/Link";
import arrowRight from "../../assets/icons/arrow-right.svg";
import { Divider } from "antd";
import { useNavigate } from "react-router-dom";
import useGetNotifications from "./hooks/useGetNotifications";
import useGetUserDetail from "../UserDetail/hooks/useGetUserDetail";
import { getUserInfo } from "../../utilities/helpers";
import ReactLoading from "react-loading";

const ApplicationHome = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });
  const { nameid } = getUserInfo();
  const { data: userDetail, isLoading: isUserDetailLoading, isSuccess: isUserDetailSuccess } = useGetUserDetail(nameid);
  const [projectsList, setProjectsList] = useState([]);
  const [selectedButton, setSelectedButton] = useState(0);
  const [filter, setFilter] = useState("");
  const { data, isLoading, isSuccess } = useGetNotifications(filter, nameid);
  const [notifications, setNotifications] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (isSuccess) {
      setNotifications(data?.data);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (isUserDetailSuccess) {
      const grouped = Object.values(
        userDetail?.data?.userDetails?.projectRoles.reduce((acc, { projectId, projectName, roleName }) => {
          if (!acc[projectId]) {
            acc[projectId] = { projectId, projectName, roles: [] };
          }
          acc[projectId].roles.push(roleName);
          return acc;
        }, {})
      ).map(item => ({
        ...item,
        roleName: item.roles.join(", ")
      }));
      
      const filtered = grouped.filter(item => item.roleName.includes("Welding Inspector"));
      setProjectsList(filtered);
    }
  }, [isUserDetailSuccess, userDetail]);

  useEffect(() => {
    const selectedFilter = {
      0: "",
      1: 2,
      2: 1,
      3: 0,
    }
    setFilter(selectedFilter[selectedButton]);
  }, [selectedButton]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 3600000);

    return () => clearInterval(interval);
  }, []);

  const notificationsButtons = [
    {
      label: "All",
      onClick: () => {
        setSelectedButton(0);
      }
    },
    {
      label: "Certifications",
      onClick: () => {
        setSelectedButton(1);
      }
    },
    {
      label: "Qualifications",
      onClick: () => {
        setSelectedButton(2);
      }
    },
    {
      label: "Projects",
      onClick: () => {
        setSelectedButton(3);
      }
    },
  ];

  const handleGoToProject = (id) => {
    navigate(`/application/project/${id}`);
  };

  const handleGoToUserInfo = () => {
    navigate(`/application/user-info/${nameid}`);
  };



  const calculateHoursAgo = (dateString) => {
    const notificationDate = new Date(dateString);
    const diffInMs = currentTime - notificationDate;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    
    if (diffInHours < 1) {
      return "Less than 1 hour ago";
    } else if (diffInHours === 1) {
      return "1 hour ago";
    } else {
      return `${diffInHours} hours ago`;
    }
  };

  return (
    <Container>
      <Div width="100%" height="55px" justify="space-between" align="center">
        <Div direction="column">
          <Text
            size={isMobile ? theme.fonts.size.h6 : theme.fonts.size.h4}
            color={theme.colors.dark}
            weight={theme.fonts.weight.bold}
          >
            Home
          </Text>
        </Div>
        <Div gap="24px">
          <Button 
            background={theme.colors.salmon} 
            width={isMobile ? "113px" : "153px"}
            height={isMobile ? "35px" : "50px"}
            onClick={handleGoToUserInfo}
          >
            User info
          </Button>
        </Div>
      </Div>
      <Div 
        width="100%" 
        direction="column"
        gap="16px" 
        m="22px 0 0 0"
      >
        <Div 
          width="100%" 
          direction={isMobile ? "column" : "row"} 
          gap={isMobile ? "24px" : "16px"}
        >
          <Div width={isMobile ? "100%" : "68%"}>
            <Card 
              padding={isMobile ? "21px 11px 27px 17px" : "20px 23px 38px 23px"} 
              style={{ 
                alignItems: "start", 
                flexDirection: "column", 
                justifyContent: "flex-start" 
              }}
            >
              <Div 
                justify="space-between" 
                align={isMobile ? "flex-start" : "center"}
                width="100%"
                style={{
                  flexDirection: isMobile ? 'column' : 'row',
                  gap: isMobile ? '13px' : '0'
                }}
              >
                <Text 
                  size={theme.fonts.size.h6} 
                  weight={theme.fonts.weight.bold} 
                  color={theme.colors.dark}
                >
                  Notifications
                </Text>
                <Div gap="8px" style={{ flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                  {notificationsButtons.map((button, index) => (
                    <Button
                      key={index}
                      background={selectedButton === index ? theme.colors.light3 : theme.colors.white}
                      width={isMobile ? "auto" : "100%"}
                      height="32px"
                      radius="16px"
                      border={selectedButton === index ? theme.colors.light3 : theme.colors.light5}
                      color={theme.colors.grey1}
                      onClick={button.onClick}
                    >
                      {button.label}
                    </Button>
                  ))}
                </Div>
              </Div>
              <NotificationsContainer>
                {isLoading ? (
                  <Div width="100%" height="100%" justify="center" align="center">
                    <ReactLoading color={theme.colors.salmon} />
                  </Div>
                ) : (
                  notifications.map((notification, index) => (
                    <NotificationsWrapper key={index}>
                      <Div justify="space-between" align="center" width="100%" m={isMobile ? "0 0 10px 0" : "0 0 4px 0"}>
                        <Text size={theme.fonts.size.default} weight={theme.fonts.weight.medium} color={theme.colors.dark}>
                          {notification.title}
                        </Text>
                        <Text size={theme.fonts.size.xs} color={theme.colors.dark}>
                          {calculateHoursAgo(notification.creationDate)}
                        </Text>
                      </Div>
                      <Div justify="space-between" align="center" width="100%" height="20px">
                        <Text size={isMobile ? theme.fonts.size.sm : theme.fonts.size.default} color={theme.colors.grey1} style={{ width: "90%"}}>
                          {notification.content}
                        </Text>
                        <Link size={theme.fonts.size.xs}>
                          Viewed
                        </Link>
                      </Div>
                    </NotificationsWrapper>
                  ))
                )}
              </NotificationsContainer>
            </Card>
          </Div>
          
          <Div width={isMobile ? "100%" : "30%"}>
            <Card 
              padding="24px 24px 27px 24px" 
              style={{ 
                alignItems: "start", 
                flexDirection: "column",
                height: "min-content"
              }}
            >
              <Text 
                size={theme.fonts.size.h6} 
                weight={theme.fonts.weight.bold} 
                color={theme.colors.dark}
              >
                Safety
              </Text>
              <Text 
                size={theme.fonts.size.sm} 
                color={theme.colors.grey1} 
                mt="6px" 
                mb="24px"
              >
                Access documentation & protocols
              </Text>
              <Button
                background={theme.colors.white}
                width="100%"
                height="35px"
                border={theme.colors.dark2}
                color={theme.colors.dark}
              >
                Access Safety Documentation
              </Button>
            </Card>
          </Div>
        </Div>
        
        <Div width={isMobile ? "100%" : "68%"}>
          <Card 
            padding={isMobile ? "24px 15px 8px 15px" : "24px 24px 27px 24px"}
            height={isMobile ? "359px" : "378px"}
            style={{ 
              alignItems: "start", 
              flexDirection: "column" 
            }}
          >
            <Text 
              size={theme.fonts.size.h6} 
              weight={theme.fonts.weight.bold} 
              color={theme.colors.dark}
            >
              Your projects
            </Text>
            <Div direction="column" width="100%" m="34px 0 0 0" style={{ overflowY: "auto", minHeight: "280px" }}>
              {isUserDetailLoading ? (
                <Div width="100%" height="100%" justify="center" align="center">
                  <ReactLoading color={theme.colors.salmon} />
                </Div>
              ) : (
                projectsList?.map((item, index) => (
                  <Div direction="column" key={index}>
                    <Div justify="space-between" align="center" height="30px">
                      <Div gap="8px" align="center" width={isMobile ? "50%" : "33.33%"}>
                        <Bullet />
                        <Text 
                          color={theme.colors.dark} 
                          weight={theme.fonts.weight.medium}
                        >
                          {item.projectName}
                        </Text>
                      </Div>
                      {!isMobile && (
                        <>
                          <Text color={theme.colors.dark} style={{ width: "33.33%", textAlign: "center" }}>
                            {item.roleName}
                          </Text>
                        </>
                      )}
                      <Link 
                        color={theme.colors.grey1} 
                        style={{ textAlign: "right", width: isMobile ? "50%" : "33.33%" }} 
                        onClick={() => handleGoToProject(item.projectId)}
                      >
                        Go to Project
                        <img alt="arrow" src={arrowRight} style={{ marginLeft: "8px" }} />
                      </Link>
                    </Div>
                    {index !== projectsList.length - 1 && (
                      <Divider style={{ margin: "21px 0 17px 0" }} />
                    )}
                  </Div>
                ))
              )}
            </Div>
          </Card>
        </Div>
      </Div>
    </Container>
  );
};

export default ApplicationHome;